import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { ChainSvg } from '../../../../assets';
import { LifeGraphExplorerFilter } from './lifegraph-explorer.types';
import { LifeGraphOverlay } from '../lifegraph-overlay';
import { LifeGraphExplorer } from './LifeGraphExplorer';
import { styles } from './lifegraph-explorer-helper';
import { Dictionary } from 'lib';

interface GraphContainerProps {
    filter: LifeGraphExplorerFilter | string | undefined;
    canvasHeight: number;
    canvasWidth: number;
    displayMode: string;
    showGraphBtn: boolean;
    onDisplayModeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    data: Dictionary[];
    colors: Record<string, string>;
    setShowGraphBtn: React.Dispatch<React.SetStateAction<boolean>>;
    forceUpdate: boolean;
    setForceUpdate: React.Dispatch<React.SetStateAction<boolean>>;
    isCanvasHeightSmall?: boolean;
    unsupportedQuery?: boolean;
    handleUnsupportedQueryClick?: () => void;
}

export const GraphContainer = ({
    filter,
    canvasHeight,
    canvasWidth,
    displayMode,
    showGraphBtn,
    onDisplayModeChange,
    data,
    colors,
    setShowGraphBtn,
    forceUpdate,
    setForceUpdate,
    isCanvasHeightSmall,
    unsupportedQuery,
    handleUnsupportedQueryClick,
}: GraphContainerProps): React.JSX.Element => {
    return (
        <Box
            sx={{
                height: `${canvasHeight}px`,
            }}
        >
            {filter ? (
                <Box sx={styles.box}>
                    <LifeGraphOverlay
                        displayMode={displayMode}
                        onDisplayModeChange={onDisplayModeChange}
                        showGraphBtn={showGraphBtn}
                    >
                        <LifeGraphExplorer
                            filter={filter}
                            dictionaries={data}
                            nodeColors={colors}
                            displayMode={displayMode}
                            canvasHeight={canvasHeight}
                            canvasWidth={canvasWidth}
                            onLoadingChange={setShowGraphBtn}
                            forceUpdate={forceUpdate}
                            setForceUpdate={setForceUpdate}
                            isCanvasHeightSmall={isCanvasHeightSmall}
                            unsupportedQuery={unsupportedQuery}
                            handleUnsupportedQueryClick={
                                handleUnsupportedQueryClick
                            }
                        />
                    </LifeGraphOverlay>
                </Box>
            ) : (
                <LifeGraphOverlay
                    displayMode={displayMode}
                    onDisplayModeChange={onDisplayModeChange}
                    showGraphBtn={false}
                >
                    <Stack sx={styles.selectChainStack}>
                        <Box>
                            <Box sx={styles.selectChainBox}>
                                <img
                                    alt='chain-image'
                                    src={ChainSvg}
                                    style={styles.chainImg}
                                />
                            </Box>
                            <Box>
                                <Typography
                                    variant='h2'
                                    sx={styles.selectChainText}
                                >
                                    Select filters to get started.
                                </Typography>
                            </Box>
                        </Box>
                    </Stack>
                </LifeGraphOverlay>
            )}
        </Box>
    );
};
